import React from "react";
import { Avatar, Button, Grid, Input, Select } from "antd";
import { SendOutlined, UserOutlined } from "@ant-design/icons";
import { POST_TYPES } from "./postTypes";

const green = "#006A4E";
const { useBreakpoint } = Grid;

const FeedComposer = ({
  postText,
  setPostText,
  postType,
  setPostType,
  onPost,
  posting,
  currentUser,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  return (
    <div
      style={{
        border: "1px solid #e6eeeb",
        borderRadius: 12,
        padding: 14,
        marginBottom: 18,
        background: "#f9fbfa",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 10,
          alignItems: "flex-start",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Avatar
          size={38}
          src={currentUser?.profilePhoto || undefined}
          icon={<UserOutlined />}
          style={{ background: "#dcefe8", color: green }}
        />
        <div style={{ flex: 1, width: "100%" }}>
          <Select
            value={postType}
            onChange={setPostType}
            options={POST_TYPES.map((type) => ({ value: type, label: type }))}
            style={{ width: "100%", marginBottom: 10 }}
          />
          <Input.TextArea
            rows={3}
            maxLength={500}
            showCount
            placeholder={
              postType === "Share whats on your mind"
                ? "Share something with the community..."
                : `Write a ${postType.toLowerCase()} post...`
            }
            value={postText}
            onChange={(e) => setPostText(e.target.value)}
            style={{ borderRadius: 10 }}
          />
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
        <Button
          type="primary"
          loading={posting}
          onClick={onPost}
          style={{ background: green, borderColor: green }}
          icon={<SendOutlined />}
        >
          Post
        </Button>
      </div>
    </div>
  );
};

export default FeedComposer;
